export default __webpack_public_path__ + "static/media/MaskGroup281.f7f7ee6f.png";